export default {
  props: {
    type: {
      type: String,
      default: "course"
    },
    width: {
      type: String,
      default: "80px"
    },
    description: {
      type: String,
      default: "暂无相关内容"
    }
  },
  data() {
    return {
      imageObj: {
        course: require("@/assets/images/empty/empty_course.png"),
        message: require("@/assets/images/empty/empty_message.png"),
        person: require("@/assets/images/empty/empty_person.png")
      }
    };
  },
  computed: {
    image() {
      let image;
      image = this.imageObj[this.type] || this.imageObj.course;
      return image;
    }
  }
};